export default __webpack_public_path__ + "static/media/autro-sense.851cecb5.png";